import { useState } from 'react';

import { POST_AUTH_PATH } from '@perpay-web/authentication/constants/paths';
import FocusContent from '@perpay-web/components/composite/FocusLayout/FocusContent';
import FocusFooter from '@perpay-web/components/composite/FocusLayout/FocusFooter';
import FocusLayout from '@perpay-web/components/composite/FocusLayout/FocusLayout';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ExploreCategoriesGrid from '@perpay-web/fintech/components/composite/SpendingLimitLanding/ExploreCategoriesGrid/ExploreCategoriesGrid';
import SpendingLimitLoader from '@perpay-web/fintech/components/composite/SpendingLimitLanding/SpendingLimitLoader/SpendingLimitLoader';
import { useFullHeader } from '@perpay-web/fintech/hooks/useFullHeaderContext';
import useLoaderStepTimeout from '@perpay-web/fintech/hooks/useLoaderStepTimeout';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { EndToEndTestIdProvider } from '@perpay-web/utils/endToEndTestIds';
import { formatCurrencyRound } from '@perpay-web/utils/stringUtils';

import styles from './SpendingLimitLanding.scss';

const SpendingLimitLanding = ({
    spendingLimit,
    initialStep = 0,
    onClickShop,
    isSoloOptOut = false,
}) => {
    const [step, setStep] = useState(initialStep);
    useLoaderStepTimeout(initialStep, () => setStep(1));

    useFullHeader(null);

    const params = new URLSearchParams(window.location.search);

    // ignore /dashboard/ as next param to allow user redirection to product page
    const nextParam =
        params.get('next') === POST_AUTH_PATH ? '' : params.get('next');

    const contentDetailsCopy = isSoloOptOut ? 'make' : 'build credit with';

    return (
        <div className={styles.wrapper}>
            {step === 0 ? <SpendingLimitLoader /> : null}
            {step === 1 ? (
                <FocusLayout className={styles['focus-layout']}>
                    <FocusContent className={styles['focus-content']}>
                        <Stack className={styles['upper-sheet']}>
                            <p className={styles.heading}>
                                Congrats! Your spending limit is
                            </p>
                            <div className={styles.limit}>
                                <span className={styles.limit__sign}>$</span>
                                <span className={styles.limit__value}>
                                    {formatCurrencyRound(
                                        spendingLimit,
                                        /* isCents */ true,
                                        /* keepCents */ false,
                                        { style: 'decimal' },
                                    )}
                                </span>
                            </div>
                            <div className={styles.copy__outline}>
                                <ResponsiveCopy className={styles.copy}>
                                    Shop 1,000+ top brands, and{' '}
                                    {contentDetailsCopy} easy payments from your
                                    paycheck
                                </ResponsiveCopy>
                            </div>
                        </Stack>
                        <ExploreCategoriesGrid />
                    </FocusContent>
                    <FocusFooter>
                        <EndToEndTestIdProvider testId='new-user-landing-start-shopping'>
                            <CustomLink
                                action='primary'
                                href={nextParam || paths.shop.path}
                                onClick={onClickShop}
                            >
                                Start Shopping
                            </CustomLink>
                        </EndToEndTestIdProvider>
                        <p className={styles.subcopy}>
                            * All purchases are subject to approval
                        </p>
                    </FocusFooter>
                </FocusLayout>
            ) : null}
        </div>
    );
};

export default SpendingLimitLanding;
